import gql from "graphql-tag";

const GET_GAME_FEEDS = gql`
  query GetGameFeeds($gamePk: Int!, $includeInternal: Boolean!) {
    gameVideoAssets(gamePk: $gamePk, includeInternal: $includeInternal) {
      assets {
        assetId
        assetName
        feedType
        videoGameDate
        playbackUrl
      }
    }
  }
`;

const TIME_IN_FEED = gql`
  query TimeInFeed(
    $assetName: String!
    $start: String!
    $end: String!
    $mode: VideoMode
  ) {
    assetOffsets(assetName: $assetName, start: $start, end: $end, mode: $mode) {
      startSeconds
      endSeconds
    }
  }
`;

const ASSET_AND_TIME_IN_FEED = gql`
  query AssetAndTimeInFeed(
    $gamePk: Int!
    $feedType: VideoFeedType!
    $start: String!
    $end: String!
  ) {
    assetAndOffsets(
      gamePk: $gamePk
      feedType: $feedType
      start: $start
      end: $end
    ) {
      assetName
      feedType
      success
      startSeconds
      endSeconds
    }
  }
`;

export { GET_GAME_FEEDS, TIME_IN_FEED, ASSET_AND_TIME_IN_FEED };



// WEBPACK FOOTER //
// ./src/httpClients/graphql/jared-queries.js